module.exports = __webpack_public_path__ + "img/WHITE_JTI.0286c0bb.svg";